import { Loader2, Mail, Plus } from 'lucide-react';
import React from 'react';
import { OrgProductMultiSelect } from '../../../../../components/team/OrgProductMultiSelect';
import { CustomSelect } from '../../../../../shared/components/CustomSelect';
import { useTeamTab } from '../../TeamTabContext';

export const InviteToOrgPanel: React.FC = () => {
  const {
    inviteEmail,
    setInviteEmail,
    inviteRole,
    setInviteRole,
    inviteLoading,
    inviteMessage,
    setInviteMessage,
    inviteError,
    setInviteError,
    inviteOrgProductIds,
    setInviteOrgProductIds,
    inviteRoleOptions,
    handleInviteOrgMember,
    visibleProductsSettings,
  } = useTeamTab();

  return (
    <div className="settings-panel settings-panel--success">
      <div className="settings-panel__header">
        <h3 className="settings-panel__title">Invite to organization</h3>
        <p className="settings-panel__description">
          Sends one email with a single link: <strong>existing Relix accounts</strong> get a
          one-time sign-in link; <strong>new email addresses</strong> get a link to create a
          password and finish joining (they're already added to this organization). This is separate
          from the <strong>team roster</strong> below, which is for capacity and reporting names
          synced from Jira.
        </p>
      </div>
      <div className="settings-panel__body">
        <div className="settings-toolbar">
          <div className="form-group" style={{ flex: '1 1 200px', marginBottom: 0 }}>
            <label htmlFor="inviteEmail" className="form-label">
              <Mail className="label-icon" />
              Email
            </label>
            <input
              id="inviteEmail"
              type="email"
              className="form-input"
              placeholder="colleague@company.com"
              value={inviteEmail}
              onChange={(e) => {
                setInviteEmail(e.target.value);
                setInviteError(null);
                setInviteMessage(null);
              }}
              disabled={inviteLoading}
            />
          </div>
          <div className="form-group" style={{ flex: '0 1 200px', marginBottom: 0 }}>
            <label htmlFor="inviteRole" className="form-label">
              Organization role
            </label>
            <CustomSelect
              id="inviteRole"
              value={inviteRole}
              options={inviteRoleOptions}
              onChange={(val) => setInviteRole(val as 'administrator' | 'member')}
              disabled={inviteLoading}
            />
          </div>
          <button
            type="button"
            className="save-button"
            style={{
              backgroundColor: '#059669',
              marginBottom: '4px',
            }}
            disabled={inviteLoading}
            onClick={() => void handleInviteOrgMember()}
          >
            {inviteLoading ? (
              <Loader2 className="button-icon profile-settings-spin" />
            ) : (
              <Plus className="button-icon" />
            )}
            {inviteLoading ? 'Sending\u2026' : 'Invite member'}
          </button>
        </div>
        <div style={{ marginTop: 14 }}>
          <OrgProductMultiSelect
            products={visibleProductsSettings}
            selectedIds={inviteOrgProductIds}
            onChange={setInviteOrgProductIds}
            disabled={inviteLoading}
            legend="Products"
            hint="Leave unchecked to use the server default product(s) for new members."
          />
        </div>
        {inviteError && (
          <p style={{ color: '#dc2626', fontSize: '13px', marginTop: '12px' }}>{inviteError}</p>
        )}
        {inviteMessage && !inviteError && (
          <p style={{ color: '#059669', fontSize: '13px', marginTop: '12px' }}>{inviteMessage}</p>
        )}
      </div>
    </div>
  );
};
